import { ApolloError } from "@apollo/client";
import { ErrorIds } from "@App/types/enums";

const checkForReasonId = (results, reasonIdToCheck) => {
  let match = false;
  results?.forEach((result) => {
    if (result.reasonId === reasonIdToCheck) {
      match = true;
    }
  });
  return match;
};

export const getEarliestReturnDate = (error) => {
  let returnDate = "";
  error.graphQLErrors[0]?.extensions?.results.forEach((result) => {
    if (result.extra?.earliestReturnDate) {
      returnDate = result.extra.earliestReturnDate;
    }
  });
  return returnDate;
};

export const ActiveInquiryExistsForNumberplate = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.ACTIVE_INQUIRY_EXISTS_FOR_NUMBER_PLATE,
  );
};

export const ActiveInquiryExistsForNumberplateAndService = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.ACTIVE_INQUIRY_EXISTS_FOR_NUMBER_PLATE_AND_SERVICE,
  );
};

export const VehicleNotFoundInExternalFleet = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.VEHICLE_NOT_FOUND_IN_EXTERNAL_FLEET,
  );
};

export const SlotAlreadyBlocked = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.SLOT_ALREADY_BLOCKED,
  );
};

export const SlotAlreadyBooked = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.SLOT_ALREADY_BOOKED,
  );
};

export const EarliestReturnDateNotReached = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.EARLIEST_RETURN_DATE_NOT_REACHED,
  );
};

export const CustomerAddressNotGiven = (error: ApolloError): boolean => {
  return checkForReasonId(error.graphQLErrors[0]?.extensions?.results, ErrorIds.CUSTOMER_ADDRESS);
};

export const NumberPlateNotFound = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.NO_NUMBER_PLATE_FOUND,
  );
};
export const NoDriverFoundForNumberPlate = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.NO_DRIVER_FOUND_FOR_NUMBER_PLATE,
  );
};
export const MeinAutoNoTyreProductInCustomerContract = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.MEIN_AUTO_NO_TYRE_PRODUCT_IN_CUSTOMER_CONTRACT,
  );
};

export const MeinAutoCustomerContractNotFound = (error: ApolloError): boolean => {
  return checkForReasonId(
    error.graphQLErrors[0]?.extensions?.results,
    ErrorIds.MEIN_AUTO_CUSTOMER_CONTRACT_NOT_FOUND,
  );
};
